import { useState, useCallback } from 'react';

const useWeaponCache = () => {
    const [weaponCache, setWeaponCache] = useState({});
    const [loadingWeapons, setLoadingWeapons] = useState(new Set());

    const loadWeaponData = useCallback(async (weaponName) => {
        if (!weaponName) return null;
        if (weaponCache[weaponName]) return weaponCache[weaponName];
        if (loadingWeapons.has(weaponName)) return null;

        setLoadingWeapons(prev => new Set(prev).add(weaponName));

        try {
            const response = await fetch(`https://api.deadlock-api.com/v1/assets/items/${weaponName}`);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            const wi = data.weapon_info || {};
            const weaponData = {
                cycleTime: wi.cycle_time || 0,
                burstShotCount: wi.burst_shot_count || 1,
                intraBurstCycleTime: wi.intra_burst_cycle_time || 0,
                maxSpinCycleTime: wi.max_spin_cycle_time || 0
            };

            setWeaponCache(prev => ({ ...prev, [weaponName]: weaponData }));
            return weaponData;
        } catch {
            return null;
        } finally {
            setLoadingWeapons(prev => {
                const newSet = new Set(prev);
                newSet.delete(weaponName);
                return newSet;
            });
        }
    }, [weaponCache, loadingWeapons]);

    return { weaponCache, loadWeaponData };
};

export default useWeaponCache;
